import { API, graphqlOperation } from 'aws-amplify';
import store from '@/store/index.js'
import { staffsByGroup, vehiclesByGroup } from '@/views/Staff/queries'
import { devicesByGroup } from '@/store/queries.js'
import { mixinMethods } from "@/main";
import { usersByPhone } from '@/views/Settings/Users/query'
import { validatePhoneNumberFormatSingle, cleanPhoneNumber } from '@/utilities/phoneNumberFormat'
import {i18n} from '@/main'
import moment from 'moment-timezone'

const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/
const INVALID_DOTS_REGEX = /^\.|\.$|\.{2,}/

export function isValidEmail(value) {
  if (!value) return false
  const localPart = value.split('@')[0]
  return EMAIL_REGEX.test(value) && !INVALID_DOTS_REGEX.test(localPart)
}

export default {

    validatePhoneNumberDA(rule, value, callback)
    {
      if (!value) {
        callback();
        return
      }
      const validator = validatePhoneNumberFormatSingle(value);
      if (!validator) callback(new Error('Please enter a valid mobile number.'));
      const associateList = store.getters['subscriptionStore/getAssociatesList'] // Get the associate list from the store
      const deviceList = store.getters['subscriptionStore/getDevices'] // Get the device list from the store
      
      value = cleanPhoneNumber(value, 'US')
      const existingAssociate = associateList.find(da => da.phone == value)
      const existingDevice = deviceList.find(device => device.phoneNumber == value)
      
      if (!!existingAssociate && !(rule.daId === existingAssociate?.id)) {
        callback(new Error('The phone number entered already exists for another Associate.'))
      } else if(!!existingDevice) {
        callback(new Error('The phone number entered already exists for a Device.'))
      } else callback();
  },

    validatePhoneNumberDevice(rule, value, callback)
    {
      if (!value) {
        callback();
        return
      }
      const validator = validatePhoneNumberFormatSingle(value);
      if (!validator) callback(new Error('Please enter a valid mobile number.'));
      callback();
    },

    async validatePhoneNumberUser(rule, value, callback)
    {
      if (!value) {
        callback()
      } else {
        const validator = validatePhoneNumberFormatSingle(value);
        if (!validator) {
          callback(new Error('Please enter a valid mobile number.'))
        }
        else {
            const associateList = store.getters['subscriptionStore/getAssociatesList']
            const deviceList = store.getters['subscriptionStore/getDevices']
            value = cleanPhoneNumber(value, 'US')
            var input = { phone: value }
            var existingPhone = await API.graphql(graphqlOperation(usersByPhone, input))
            var isPhoneInSameTennant = false;
            var userTennats = existingPhone.data.usersByPhone.items.map(da => { return da.group })
            for(var user of userTennats) {
              isPhoneInSameTennant = user.includes(rule.params.group)
              if(isPhoneInSameTennant) break;
            }
            var daIds = existingPhone.data.usersByPhone.items.map(da => { return da.id })
            if(rule.params.daId) var isCurrentDa = daIds.includes(rule.params.daId)

            const existingDevice = deviceList.find(device => device.phoneNumber == value)

            if(daIds.length && !isCurrentDa && isPhoneInSameTennant) {
                callback(new Error('The phone number entered already exists.'))
            }else if(!!existingDevice) {
                callback(new Error('The phone number entered is already in use by a Device.'))
            }else {
                callback();
            }
        }
      }
    },
    
    async uniqueVIN(rule, vin, callback){
      if(vin) {
        try {
          const vehicles = store.getters['subscriptionStore/getVehicles']
          const existingVehicle = vehicles.find(vehicle => vehicle.vin?.toLowerCase() == vin.toLowerCase())
          if ((rule.daId != existingVehicle?.id) && !!existingVehicle) return callback(new Error(`A VIN already exists with this vehicle.`))
        } catch (error) {
          console.error('error', error);
        }
      }
      callback()
    },  

    async uniqueEmailDA(rule, email, callback){
      let associateList = store.getters['subscriptionStore/getAssociatesList'] // Get the associate list from the store
      // if data is not loaded in the store yet, get the data from the graphql
      if (!associateList.length) {
        const input = { group: store.state.userInfo.tenant.group }
        associateList = await mixinMethods.gLoadListAll(staffsByGroup, input, 'staffsByGroup');
      }
      if(email){
        const existingAssociate = associateList.find(da => da.email?.toLowerCase() == email.toLowerCase())
        if (!(rule.daId === existingAssociate?.id) && !!existingAssociate) return callback(new Error(`${i18n.t('label.An_associate')} already exists with this email.`))
      }
      else if(rule.required && !email) return callback(new Error("Please input an email address"))
      callback()
    },  

    async uniqueNameDevice(rule, name, callback) {
      let deviceList = store.getters['subscriptionStore/getDevices']; // Get the device list from the store
    
      // if data is not loaded in the store yet, get the data from the GraphQL
      if (!deviceList.length) {
        const input = { group: store.state.userInfo.tenant.group };
        deviceList = await mixinMethods.gLoadListAll(devicesByGroup, input, 'devicesByGroup');
      }
    
      if (name) {
        // Find a device where the name matches the provided name, excluding the current device being validated
        const existingDevice = deviceList.find(device => device.deviceName?.toLowerCase() === name.toLowerCase() && device.id !== rule.deviceId);
    
        if (existingDevice) {
          callback(new Error(`Device already exists with this name.`));
          return;
        }
      } else if (rule.required && !name) {
        callback(new Error("Please input device name"));
        return;
      }
      callback();
  },

    async uniquePhoneNumberDevice(rule, phoneNumber, callback) {
      let deviceList = store.getters['subscriptionStore/getDevices']; 
      let associateList = store.getters['subscriptionStore/getAssociatesList']
      let userList = store.getters['subscriptionStore/getUsers']

      if (!deviceList.length) {
        const input = { group: store.state.userInfo.tenant.group };
        deviceList = await mixinMethods.gLoadListAll(devicesByGroup, input, 'devicesByGroup');
      }
      phoneNumber = cleanPhoneNumber(phoneNumber, 'US')
      if (phoneNumber) {
        const existingDevice = deviceList.find(device => device.phoneNumber === phoneNumber && device.id !== rule.deviceId);
        const existingAssociate = associateList.find(da => da.phone === phoneNumber)
        const existingUser = userList.find(user => user.phone === phoneNumber)
        if (existingDevice) {
            callback(new Error(`Device already exists with this Phone Number.`));
            return;
        } else if (existingAssociate) {
            callback(new Error(`Provided number is already in use by an Associate.`));
            return;
        } else if (existingUser) {
            callback(new Error(`Provided number is already in use by a User.`));
            return;
        }
      } else if (rule.required && !phoneNumber) {
        callback(new Error("Please input device Phone Number"));
        return;
      }
      callback();
    },

    async validateLicensePlateAndState(rule, value, callback, form) {
      var isValidationError = false;
      if (rule.fieldName == 'license') {
        if ((rule.formField.licensePlate == '' || rule.formField.licensePlate == null) && rule.formField.state != '') {
          isValidationError = true;
          callback(new Error('License Plate is required when you provide a state.'));
        } else {
          if(!isValidationError) form.clearValidate('state');
        }
      } else if (rule.fieldName == 'state') {
        if ((rule.formField.state == '' || rule.formField.state == null) && rule.formField.licensePlate != '') {
          isValidationError = true;
          callback(new Error(`License State is required if you add a License Plate.`));
        }else if(rule.formField.state != null && (rule.formField.licensePlate == '' || rule.formField.licensePlate == null)){
          isValidationError = true;
          form.clearValidate('state');
        } else {
          if(!isValidationError) form.clearValidate('licensePlate');
        }
      }
      if (rule.formField.licensePlate == '' && rule.formField.state == '') {
        callback();
      } else {
        try {
          let currentCombination = (rule.formField.licensePlate + rule.formField.state).trim();
          const vehicles = store.getters['subscriptionStore/getVehicles']
    
          let isDuplicated = false;
          for (let vehicle of vehicles) {
            if (vehicle.id !== rule.formField.id) { // Check if the vehicle is not the current one being edited
              let combination = (vehicle.licensePlate + vehicle.state) || '';
              if (currentCombination.toLowerCase() == combination?.toLowerCase()) {
                isDuplicated = true;
                break;
              }
            }
          }
          if (isDuplicated) {
            isValidationError = true;
            callback(new Error('The License Plate and State already exist.'))
          } else {
            // Clear the error for both fields
            if(!isValidationError) form.clearValidate(['licensePlate', 'state']);
            callback();
          }
        } catch (error) {
          console.error('error validating license plate', error);
        }
      }
    },
    
    async uniqueTransporterIdDA(rule, transporterId, callback){
      let associateList = store.getters['subscriptionStore/getAssociatesList'] // Get the associate list from the storelet associateList = []
      // if data is not loaded in the store yet, get the data from the graphql
      if (!associateList.length) {
        const input = { group: store.state.userInfo.tenant.group }
        associateList = await mixinMethods.gLoadListAll(staffsByGroup, input, 'staffsByGroup');
      }
      if(transporterId){
        const existingAssociate = associateList.find(da => da.transporterId?.toLowerCase() == transporterId.toLowerCase())
        if (!(rule.daId === existingAssociate?.id) && !!existingAssociate) return callback(new Error(`${i18n.t('label.An_associate')} already exists with this Transporter ID.`))
      }
      callback()
    },  

    /**
     * Custom validator that ensures something resembling an email is present.
     * @param {Object} rule 
     * @param {String} value 
     * @param {Function} callback 
     */
    email(rule, value, callback){
        if( !isValidEmail(value) ) {
            let message = rule.message || "A valid email is required"
            return callback(new Error(message))
        }
        callback()
    },

    vehicleNameFormatAndRequired(rule, value, callback){
      if(!value){
        let message = rule.message || "A vehicle name is required"
        callback(new Error(message))
      }
      /**
       * 
       *Must be between 3 and 63 characters long.
        Can consist only of letters, numbers, dots (.), and hyphens (-).
        Must begin and end with a letter or number.
        Can't begin with "xn--".
       */
      var re = /^(?!xn--)[a-zA-Z0-9]{1}[a-zA-Z0-9-.]{1,61}[a-zA-Z0-9]{1}$/
      var isValid = re.test(value);

      if(!isValid){
        let message = rule.message || "A value name is required. Use rules listed below"
        callback(new Error(message))
      }
      callback()
    },
    async validateDuplicateVehicleName(rule, name, callback) {
      let vehicles = store.getters['subscriptionStore/getVehicles']
      if (!vehicles.length) {
        const input = { group: store.state.userInfo.tenant.group }
        vehicles = await mixinMethods.gLoadListAll(vehiclesByGroup, input, 'vehiclesByGroup');
      }
      const existingVehicle = vehicles.find(vehicle => vehicle.name?.toLowerCase() == name.toLowerCase())
      
      if (existingVehicle && existingVehicle.id != rule.formField.id) {
          callback(new Error('This vehicle name already exists'));
      } else {
        callback();
      }
    },

    async validateMaximumLength(rule, value, callback) {
      const maxLength = rule.maxLength || 15
      const fieldLabel = rule.fieldLabel || 'Value'
      if (value?.trim().length > maxLength) {
        callback(new Error(`${fieldLabel} must be ${maxLength} characters or less`))
        return
      }
      callback()
    },

    async validateExactLength(rule, value, callback) {
      console.log('value.trim().length: ', value.trim().length)
      if (!value || !value.trim()) {
        callback()
        return
      }
      const exactLength = rule.exactLength || 15
      const fieldLabel = rule.fieldLabel || 'Value'
      if (value?.trim().length !== exactLength) {
        callback(new Error(`${fieldLabel} must be exactly ${exactLength} characters`))
        return
      }
      callback()
    },

    async validateValueHasOnlyNumbers(rule, value, callback) {
      if (!value || !value.trim()) {
        callback()
        return
      }
      const regex = /^\d+$/
      const valueHasOnlyNumbers = regex.test(value?.trim())
      if (!valueHasOnlyNumbers) {
        callback(new error(`Value must have only numbers`))
        return
      }
      callback()
    },

    time(rule, value, callback){
        var re = /^((1[0-2])|(0?[0-9])):[0-5][0-9](a|p|A|P)(m|M)$/g
        if (!value) {
          callback(new Error('Invalid Time. Use format HH:MMAM/PM'));
        }
        else if (!value.match(re)) {
          callback(new Error('Invalid Time. Use format HH:MMAM/PM'));
        }
        else {
          callback();
        }
    },

    timeNotConfirmed(rule, value, callback){
      var re = /^((1[0-2])|(0?[0-9])):[0-5][0-9](a|p|A|P)(m|M)$/g
      if (!value) {
        callback();
      }
      else if (!value.match(re)) {
        callback(new Error('Invalid Time. Use format HH:MMAM/PM'));
      }
      else {
        callback();
      }
  },

    staff(rule, value, callback){
      if(!value || !value.id){
        let message = rule.message || `Please select ${i18n.t('label.an_associate')}`
        callback(new Error(message))
      }
      else {
        callback();
      }
    },

    incidentType(rule, value, callback){
      if(!value || !value.id){
        let message = rule.message || "Please select an issue type"
        callback(new Error(message))
      }
      else {
        callback();
      }
    },

    verifiedBy(rule, value, callback){
      if(!value.id){
        let message = rule.message || "Please select a verifiedBy"
        callback(new Error(message))
      }
      else {
        callback();
      }
    },

    user(rule, value, callback){
      if(!value.id){
        let message = rule.message || "Please select a user"
        callback(new Error(message))
      }
      else{
        callback();
      }
    },
    
    odometerType(rule, value, callback){
      if(!value){
        let message = rule.message || "Please select a type"
        callback(new Error(message))
      }
      else{
        callback();
      }
    },

    delete(rule, value, callback){
      if(value) value = value.toLowerCase().trim()
      if( value != 'delete' ) {
          let message = rule.message || "Please enter the correct phrase to confirm"
          return callback(new Error(message))
      }
      callback()
  },


  vehicle(rule, value, callback){
    if(!value || !value.id){
      let message = rule.message || "Please select a vehicle"
      callback(new Error(message))
    }
    else {
      callback();
    }
  },

  assigneeCheck(rule, value, callback){
    if(value.id == null || value.id == undefined || value.id == ""){
      let message = rule.message || "Please select an assignee"
      callback(new Error(message))
    }
    else {
      callback();
    }
  },

  maintenanceReminder(rule, value, callback){
    const validateDueByDate = rule?.dueByDate ? moment(rule.dueByDate).isValid() : null;
    if(!validateDueByDate && !rule.dueByMileage){
      let message = rule.message || "Date or mileage must be filled in"
      callback(new Error(message))
    }
    else{
      callback();
    }
  },

  maintenanceServices(rule, value, callback){
    if(!value || value.length == 0){
      let message = rule.message || "A service must be selected"
      callback(new Error(message))
    }
    else{
      callback();
    }
  },

  maintenanceVehicles(rule, value, callback){
    if(!value || value.length == 0){
      let message = rule.message || "A Vehicle must be selected"
      callback(new Error(message))
    }
    else{
      callback();
    }
  },

  noWhitespaceOnly(rule, value, callback) {
    if (value && value.trim().length === 0) {
      callback(new Error(rule.message || 'This field cannot be empty or whitespace only'));
    } else {
      callback();
    }
  },

  scheduledToSendAt(rule, value, callback, previousValue, isModal = true) {
    if (!value) return callback()
    if (previousValue && previousValue === value) return callback()

    const selectedDate = new Date(value)
    const tenantDatetime = new Date(mixinMethods.getTenantDatetimeAsString())

    const customModalText = 'click "Cancel" and send this Counseling now instead.'

    // Checks if the selected date is at least 15 minutes in the future
    if (selectedDate.getTime() < tenantDatetime.getTime() + 15 * 60 * 1000) {
      callback(new Error(
        `Please choose a time more than 15 minutes from now, or you can ${isModal ? customModalText : 'send this Counseling now with the buttons below.'}`
      ))
    // Checks if the selected date is not more than 14 days in the future.
    } else if (selectedDate.getTime() > tenantDatetime.getTime() + 14 * 24 * 60 * 60 * 1000) {
      callback(new Error('Counselings cannot be scheduled more than 14 days from now.'))
    } else {
      callback()
    }
  }
}
